import * as THREE from 'three'
import Experience from "../Experience.js";
import anim from '../Utils/Anim.js';
import Flower from './assets/Flower.js';
import redMatCapVertex from '../../shaders/redMatcap/vertex.glsl'
import redMatCapFragment from '../../shaders/redMatcap/fragment.glsl'

export default class Tableau6 {
    constructor(_options) {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.ressources = this.experience.ressources
        this.time = this.experience.time
        // 
        this.isDestroyed = false
        this.targetPos = _options.targetPos
        // 
        this.setMaterials()

        this.flower = new Flower({
            targetPos: this.targetPos,
            materials: this.materials
        })


    }
    setMaterials() {
        this.materials = {}

        this.redMatcap = this.ressources.items.redMatCap
        this.blackMatcap = this.ressources.items.blackMatCap

        this.redMatcap.minFilter = THREE.LinearFilter;
        this.redMatcap.magFilter = THREE.LinearFilter;

        this.blackMatcap.minFilter = THREE.LinearFilter;
        this.blackMatcap.magFilter = THREE.LinearFilter;
        // 
        this.noise = this.ressources.items.noise.clone();
        this.noise.wrapS = THREE.RepeatWrapping;
        this.noise.wrapT = THREE.RepeatWrapping;
        this.noise.needsUpdate = true;




        this.globalUniforms = {
            u_time: new THREE.Uniform(0),
            u_noise: new THREE.Uniform(this.noise),
            u_appear: new THREE.Uniform(0),
        }

        this.materials.redMat = new THREE.ShaderMaterial({
            vertexShader: redMatCapVertex,
            fragmentShader: redMatCapFragment,
            transparent: true,
            uniforms: {
                ...this.globalUniforms,
                u_tex: new THREE.Uniform(this.redMatcap),
            }
        })
        this.materials.blackMat = new THREE.ShaderMaterial({
            vertexShader: redMatCapVertex,
            fragmentShader: redMatCapFragment,
            transparent: true,
            uniforms: {
                ...this.globalUniforms,
                u_tex: new THREE.Uniform(this.blackMatcap),
            }
        })


    }

    destroy() {



    }


    resize() {
        if (!this.isDestroyed) {

        }

    }
    update() {
        if (!this.isDestroyed) {

            // this.globalUniforms.u_time.value = this.time.elapsed * 0.001;
            // this.globalUniforms.u_appear.value = Math.abs(Math.cos(this.time.elapsed * 0.0007))

            this.flower.update()

        }


    }
}